// src/services/servicioAutenticacion.js (admin)
import api from './api.js';
import almacen from './almacen.js';
const _a = almacen;

const CLAVE_TOKEN_ACCESO          = 'token_acceso_admin';
const CLAVE_TOKEN_REFRESCO        = 'token_refresco_admin';
const CLAVE_TOKEN_ACCESO_LEGADO   = 'access_token';
const CLAVE_TOKEN_REFRESCO_LEGADO = 'refresh_token';

function migrarTokensLegado() {
  const tokenLegado    = _a.getItem(CLAVE_TOKEN_ACCESO_LEGADO);
  const refrescoLegado = _a.getItem(CLAVE_TOKEN_REFRESCO_LEGADO);

  if (!_a.getItem(CLAVE_TOKEN_ACCESO) && tokenLegado) {
    _a.setItem(CLAVE_TOKEN_ACCESO, tokenLegado);
  }
  if (refrescoLegado && !_a.getItem(CLAVE_TOKEN_REFRESCO)) {
    _a.setItem(CLAVE_TOKEN_REFRESCO, refrescoLegado);
  }
}

export async function iniciarSesion(correo, clave) {
  const { data } = await api.post('/autenticacion/iniciar', { correo, clave });
  const tokens = data?.data;

  // El usuario tiene 2FA activo: falta el segundo paso con codigo TOTP
  if (tokens?.requiere_2fa) {
    return { requiere2fa: true, token2fa: tokens.token_2fa };
  }

  if (!tokens?.access_token) {
    throw new Error('Token de acceso no recibido');
  }
  guardarTokens(tokens);
  return tokens;
}

export async function completarDosFactores(token2fa, codigo) {
  const { data } = await api.post('/autenticacion/iniciar-2fa', {
    token_2fa: token2fa,
    codigo
  });
  const tokens = data?.data;
  if (!tokens?.access_token) {
    throw new Error('Token de acceso no recibido');
  }
  guardarTokens(tokens);
  return tokens;
}

function guardarTokens(tokens) {
  _a.setItem(CLAVE_TOKEN_ACCESO, tokens.access_token);
  if (tokens.refresh_token) {
    _a.setItem(CLAVE_TOKEN_REFRESCO, tokens.refresh_token);
  }
}

export function cerrarSesion() {
  _a.removeItem(CLAVE_TOKEN_ACCESO);
  _a.removeItem(CLAVE_TOKEN_REFRESCO);
  _a.removeItem(CLAVE_TOKEN_ACCESO_LEGADO);
  _a.removeItem(CLAVE_TOKEN_REFRESCO_LEGADO);
  window.location.href = '/iniciar-sesion';
}

export async function refrescarSesion() {
  migrarTokensLegado();
  const rt = _a.getItem(CLAVE_TOKEN_REFRESCO);
  if (!rt) throw new Error('No hay token de refresco');
  const { data } = await api.post('/autenticacion/refrescar', { refresh_token: rt });
  const access = data?.access_token;
  if (access) _a.setItem(CLAVE_TOKEN_ACCESO, access);
  return data;
}

export async function obtenerPerfil() {
  const { data } = await api.get('/autenticacion/perfil');
  return data;
}

function decodificarJwt(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(payload)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function estaAutenticado() {
  migrarTokensLegado();
  const t = _a.getItem(CLAVE_TOKEN_ACCESO);
  if (!t) return false;
  const p = decodificarJwt(t);
  if (!p || !p.exp) return false;
  return p.exp * 1000 > Date.now();
}

export function obtenerTokenAcceso() {
  migrarTokensLegado();
  return _a.getItem(CLAVE_TOKEN_ACCESO);
}

export default {
  iniciarSesion,
  completarDosFactores,
  cerrarSesion,
  refrescarSesion,
  obtenerPerfil,
  estaAutenticado,
  obtenerTokenAcceso
};
